export default "__VITE_ASSET__CkHdq9o$__"